/**
 * Returns a new array with duplicates removed, keeping the first item for each
 * distinct key. Items whose key is `null` or `undefined` are dropped.
 *
 * @example
 * uniqueBy(suppliers, (supplier) => supplier?.id);
 */
export const uniqueBy = <T, K>(items: readonly T[], getKey: (item: T) => K): T[] => {
  const seen = new Set<K>();

  return items.filter((item) => {
    const key = getKey(item);
    if (key == null || seen.has(key)) return false;

    seen.add(key);
    return true;
  });
};
